module.exports = __webpack_public_path__ + "static/media/sms-walink-2.21c45c8f.jpg";